import labels from "webforms/formio/_labels";

export default {
  "Label,Id": labels.label,
  "-Label,Id": labels.label,
  "Type,Id": labels.type,
  "-Type,Id": labels.type,
  // "Cover,Id": labels.cover,
  // "-Cover,Id": labels.cover,
};
